import axios from 'axios';

export const fetchGruposRecursos = () =>
  axios.get(`${import.meta.env.VITE_APP_API_URL}grupos-recursos`).then(
    res => res.data);

export const fetchRecursosByGrupo = (grupoId) =>
  axios.get(`${import.meta.env.VITE_APP_API_URL}recursos`, { params: { grupo_id: grupoId } }).then(res => res.data);
